/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import TaxPersonalTable02 from "./components/table2";
import TaxPersonalTable03 from "./components/table3";
import TaxPersonalTable04 from "./components/table4";
import TaxPersonalTable05 from "./components/table5";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import Footer from "./components/footer";
import Fields from "./components/field";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Fields2 from "./components/field2";

export default function TaxPersonal11() {
  const { formId, formField } = form;
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([
    { name: "05-1/BK-TNCN", checked: false },
    { name: "05-2/BK-TNCN", checked: false },
    { name: "05-3/BK-TNCN", checked: false },
  ]);

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions list={list} pickAll={pickAll} setPickAll={setPickAll} />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent list={list} setList={setList} pickAll={pickAll} setPickAll={setPickAll} />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai quyết toán thuế thu nhập cá nhân - Mẫu 05/QTT-TNCN
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với tổ chức, cá nhân trả thu nhập chịu thuế từ tiền lương, tiền công)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      errors,
                      touched,
                      formField,
                    }}
                  />
                  <TaxPersonalTable setFieldValue={setFieldValue} />
                  <TaxPersonalTable02 setFieldValue={setFieldValue} />
                  <Footer
                    formData={{
                      values,
                      errors,
                      touched,
                      formField,
                    }}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 1 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Bảng kê chi tiết cá nhân
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thuộc diện tính thuế theo biểu lũy tiến từng phần
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Kèm theo tờ khai quyết toán thuế thu nhập cá nhân mẫu số 05/QTT-TNCN)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      errors,
                      touched,
                      formField,
                    }}
                  />
                  <TaxPersonalTable03 setFieldValue={setFieldValue} />
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 2 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Bảng kê chi tiết cá nhân
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thuộc diện tính thuế theo thuế suất toàn phần
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Kèm theo tờ khai quyết toán thuế thu nhập cá nhân mẫu số 05/QTT-TNCN)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      errors,
                      touched,
                      formField,
                    }}
                  />
                  <TaxPersonalTable04 setFieldValue={setFieldValue} />
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 3 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Bảng kê chi tiết cá nhân người phụ thuộc giảm trừ gia cảnh
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Kèm theo tờ khai quyết toán thuế thu nhập cá nhân mẫu số 05/QTT-TNCN)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      errors,
                      touched,
                      formField,
                    }}
                  />
                  <TaxPersonalTable05 setFieldValue={setFieldValue} />
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}
